import { render } from "./AdminHeaderActions.vue?vue&type=template&id=4538cdb6&scoped=true"
import script from "./AdminHeaderActions.vue?vue&type=script&lang=js"
export * from "./AdminHeaderActions.vue?vue&type=script&lang=js"

import "./AdminHeaderActions.vue?vue&type=style&index=0&id=4538cdb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4538cdb6"]])

export default __exports__